module.exports = __webpack_public_path__ + "media/images/world-c25e55cd.svg";